import { UbisoftProfile, UbisoftUser } from '../models/ubisoft';
import { UBI_SERVICES } from '../utils/constants';
import { ubisoftServices } from './repositories';

export const getProfile = (id: string) =>
  ubisoftServices()
    .get<UbisoftProfile>(`${UBI_SERVICES.endpoints.profiles}/${id}`)
    .then((response: any) => response.data);

export const getUser = (id: string) =>
  ubisoftServices()
    .get<UbisoftUser>(`${UBI_SERVICES.endpoints.users}/${id}`)
    .then((response: any) => response.data);
